import { telegram } from "./telegram";

/**
 * Тема хранится в localStorage (а не в IndexedDB): её читает inline-скрипт в index.html
 * синхронно до первой отрисовки — без вспышки светлого экрана.
 */
export type ThemePref = "dark" | "light" | "system";
const KEY = "mantra-theme";
export const DEFAULT_THEME: ThemePref = "dark";

export function getTheme(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === "dark" || v === "light" || v === "system" ? v : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function applyTheme(pref: ThemePref = getTheme()): void {
  const root = document.documentElement;
  // «Как в системе» внутри Telegram — значит как в Telegram
  const tg = telegram()?.colorScheme;
  const resolved = pref === "system" ? (tg ?? null) : pref;
  if (resolved) root.dataset.theme = resolved;
  else delete root.dataset.theme;

  const bg = getComputedStyle(root).getPropertyValue("--bg").trim();
  document.querySelectorAll('meta[name="theme-color"]').forEach((m) => m.setAttribute("content", bg));
  const wa = telegram();
  if (wa && bg) {
    wa.setHeaderColor(bg);
    wa.setBackgroundColor(bg);
  }
}

export function setTheme(pref: ThemePref): void {
  try {
    localStorage.setItem(KEY, pref);
  } catch {
    /* приватный режим — тема просто не запомнится */
  }
  applyTheme(pref);
}

export function watchSystemTheme(): void {
  window.matchMedia?.("(prefers-color-scheme: light)").addEventListener?.("change", () => {
    if (getTheme() === "system") applyTheme("system");
  });
}
